<template>
  <div class="list-group-item mb-2 " :style="shipment.status === 'pending' ? { opacity: 0.5 } : ''">
    <div class=" d-flex justify-content-between align-items-center">
      <div>{{ shipment.shipment.receiver.name1 }}</div>
      <div class="flex-grow-1 text-right">
        <span class="mr-3">{{ shipment.shipment.item.weightInKG.toString().replace('.', ',') }} kg</span>
        <span style="display: inline-block; min-width: 5rem;">{{ shipment.shipment.item.shippingBox }}</span>
      </div>
      <div v-if="shipment.status === 'success'" style="width: 200px; text-align: right">
        <button @click="openShipmentLabel(shipment.labelUrl)" class="btn btn-success ">
          <i class="fas fa-print"></i>
          Print
        </button>
      </div>
      <div v-else-if="shipment.status === 'error'" style="width: 200px; text-align: right">
        <button disabled class="btn btn-outline-danger">
          Error
        </button>
      </div>
      <div v-else-if="shipment.status === 'pending'" style="width: 200px; text-align: right">
        <button disabled class="btn btn-outline-primary">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading...
        </button>
      </div>
      <div v-else-if="shipment.status === 'deleted'" style="width: 200px; text-align: right;">
        <button disabled class="btn btn-outline-danger">
          Deleted
        </button>
      </div>
      <DotMenu v-if="shipment.status !== 'deleted'">
        <li @click="copyToClipboard(shipment.id)">Copy Shipment ID</li>
        <li @click="deleteShipment" class="text-danger">Delete</li>
      </DotMenu>
      <DotMenu v-else>
        <li>Deleted</li>
      </DotMenu>
    </div>
    <small v-if="shipment.error" class="text-danger">{{ shipment.error.statusMessage }}</small>
    <small v-else-if="shipment.status === 'deleted'" class="text-danger">Shipment was removed</small>
  </div>
</template>

<script>
import DotMenu from '@/shared/DotMenu'
import { functions } from '@/shared/firebase'

export default {
  components: { DotMenu },
  props: ['shipment'],

  methods: {
    openShipmentLabel(url) {
      window.open(url, '_blank')
    },
    deleteShipment() {
      if (confirm('Are you sure do delete the shipment?')) {
        const deleteShipment = functions.httpsCallable('deleteShipment')
        deleteShipment({
          shipmentNumber: this.shipment.shipmentNumber,
          shipmentId: this.shipment.id,
          orderId: this.shipment.orderId
        })
          .then(() => {})
          .catch(e => {
            this.errors = e
          })
      }
    }
  }
}
</script>
